// Libraries
import { Button, Icon } from "@mui/material";
import clsx from "clsx";

type TButtonDirectionProps = {
	disabled: boolean;
	iconDirection: string;
	direction: "left" | "right";
	onClick: () => void;
};

export default function ButtonDirection(props: Readonly<TButtonDirectionProps>) {
	const { disabled, iconDirection, direction, onClick } = props;

	return (
		<Button
			className={clsx({
				"!rounded-[6px] !h-[30px] !w-[60px] !shadow-none": true,
				"!bg-primary": !disabled,
			})}
			variant="contained"
			size="small"
			onClick={onClick}
			disabled={disabled}
			aria-label={`move selected ${direction}`}
		>
			<Icon className="!text-default !text-[12px] !ml-1 !inline-flex">
				<img src={iconDirection} />
			</Icon>
		</Button>
	);
}
